import { render, staticRenderFns } from "./CustoEventoForm.vue?vue&type=template&id=4027103c&scoped=true"
import script from "./CustoEventoForm.vue?vue&type=script&lang=js"
export * from "./CustoEventoForm.vue?vue&type=script&lang=js"
import style0 from "./CustoEventoForm.vue?vue&type=style&index=0&id=4027103c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027103c",
  null
  
)

export default component.exports